import React, { useState, useEffect, useContext } from "react";
import {
  Box,
  TextField,
  MenuItem,
  Paper,
  Grid,
  Typography,
} from "@mui/material";
import { Search } from "@mui/icons-material";
// import AirSystem from "@/components/checklist/air-system";
// import CustomDropDown from "@/components/custom-dropdown";
import {
  CATEGORY_TABS_LIST,
  ELECTRICAL_SYSTEM_QUESTIONS,
  ENGINE_CONDITION_QUESTIONS,
  ENGINE_SIDE_QUESTIONS,
  FUEL_SYSTEM_QUESTIONS,
  LOC_TRAIL_QUESTION,
  LUBE_SYSTEM_QUESTIONS,
  mappingElectricalSystemDetailsToUI,
  mappingEngineConditionDetailsToUI,
  mappingEngineSideDetailsToUI,
  mappingFuelSystemDetailsToUI,
  mappingLOCTrailDetailsToUI,
  mappingLubeSystemDetailsToUI,
  mappingOtherDetailsToUI,
  mappingOverHeatDetailsToUI,
  mappingVehicleEndDetailsToUI,
  OTHER_OBSERVATION_QUESTIONS,
  OVER_HEAT_QUESTIONS,
  VEHICLE_END_QUESTIONS,
} from "./config";
// import { useLocalSearchParams } from "expo-router";
import CustomModal from "../../core/modal";
import SiAutocomplete from "../../core/si-autocomplete";
// import CoolentCondition from "./coolent-condition";
import { HTTP_METHODS, invokeApi } from "../../utils/http-service";
import { HOSTNAME, REST_URLS } from "../../utils/endpoints";
import { toast } from "react-toastify";
import RenderForm from "./render-form";
import {
  COOLANT_QUESTIONS,
  mappingCoolantDetailsToUI,
} from "./coolent-condition-helper";
import AirSystem from "./air-system";
import { USER_ROLES } from "../../utils/constants";
import AppContext from "../../utils/context";

export default function Checklist({ setIsChecklist, ticketId }) {
  //   const classes = useStyles();
  //   const params = useLocalSearchParams();
  const [activeTab, setActiveTab] = useState(CATEGORY_TABS_LIST[0]);
  const { userDetails = {} } = useContext(AppContext);
  const [checklistData, setChecklistData] = useState({});
  const [searchQuery, setSearchQuery] = useState("");
  const [modifiedDetails, setModifiedDetails] = useState({});
  const classes = {};
  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };
  const loadCheckList = () => {
    let url = `${HOSTNAME}${REST_URLS.GET_JIR_FROM_TICKET}/checklist/${ticketId}`;
    if (userDetails.role === USER_ROLES.OEM) {
      url = `${HOSTNAME}${REST_URLS.OEM_GET_JIR_FROM_TICKET}/checklist/${ticketId}`;
    }
    invokeApi(HTTP_METHODS.GET, url)
      .then((res) => {
        if (res.message) {
          toast.error(res.message);
        } else {
          setChecklistData(res);
        }
      })
      .catch((err) => console.error(err));
  };

  const renderActiveTabComponent = () => {
    switch (activeTab?.value) {
      case CATEGORY_TABS_LIST[0].value:
        return (
          <AirSystem
            data={checklistData?.airIntakeAndExhaustSystemCheckList || {}}
          />
        );
      case CATEGORY_TABS_LIST[1].value:
        return (
          <RenderForm
            data={checklistData?.fuelSystem || {}}
            title="Fuel System"
            QUESTIONS={FUEL_SYSTEM_QUESTIONS}
            mappingDetailsToUI={mappingFuelSystemDetailsToUI}
          />
        );
      case CATEGORY_TABS_LIST[2].value:
        return (
          <RenderForm
            data={checklistData?.lubricationSystem || {}}
            title="Lube System"
            QUESTIONS={LUBE_SYSTEM_QUESTIONS}
            mappingDetailsToUI={mappingLubeSystemDetailsToUI}
          />
        );
      case CATEGORY_TABS_LIST[3].value:
        return (
          <RenderForm
            data={checklistData?.coolantSystem || {}}
            title="Coolant Condition"
            QUESTIONS={COOLANT_QUESTIONS}
            mappingDetailsToUI={mappingCoolantDetailsToUI}
          />
        );
      case CATEGORY_TABS_LIST[4].value:
        return (
          <RenderForm
            data={checklistData?.overHeating || {}}
            title="Over Heated"
            QUESTIONS={OVER_HEAT_QUESTIONS}
            mappingDetailsToUI={mappingOverHeatDetailsToUI}
          />
        );
      case CATEGORY_TABS_LIST[5].value:
        return (
          <RenderForm
            data={checklistData?.electricalSystem || {}}
            title="Electrical System"
            QUESTIONS={ELECTRICAL_SYSTEM_QUESTIONS}
            mappingDetailsToUI={mappingElectricalSystemDetailsToUI}
          />
        );
      case CATEGORY_TABS_LIST[6].value:
        return (
          <RenderForm
            data={checklistData?.otherEngineSystem || {}}
            title="Engine Side"
            QUESTIONS={ENGINE_SIDE_QUESTIONS}
            mappingDetailsToUI={mappingEngineSideDetailsToUI}
          />
        );
      case CATEGORY_TABS_LIST[7].value:
        return (
          <RenderForm
            data={checklistData?.engineConditionAfterDismantling || {}}
            title="Engine condition after dismantling"
            QUESTIONS={ENGINE_CONDITION_QUESTIONS}
            mappingDetailsToUI={mappingEngineConditionDetailsToUI}
          />
        );
      case CATEGORY_TABS_LIST[8].value:
        return (
          <RenderForm
            data={checklistData?.vehicleEnd || {}}
            title="Vehicle END"
            QUESTIONS={VEHICLE_END_QUESTIONS}
            mappingDetailsToUI={mappingVehicleEndDetailsToUI}
          />
        );
      case CATEGORY_TABS_LIST[9].value:
        return (
          <RenderForm
            data={checklistData?.lubeOilConsumption || {}}
            title="LOC Trial"
            QUESTIONS={LOC_TRAIL_QUESTION}
            mappingDetailsToUI={mappingLOCTrailDetailsToUI}
          />
        );
      case CATEGORY_TABS_LIST[10].value:
        return (
          <RenderForm
            data={checklistData?.otherObservation || {}}
            title="Other Observation"
            QUESTIONS={OTHER_OBSERVATION_QUESTIONS}
            mappingDetailsToUI={mappingOtherDetailsToUI}
          />
        );

      default:
        return (
          <Typography sx={{ textAlign: "center", mt: 3 }}>
            Select Checklist Type
          </Typography>
        );
    }
  };
  useEffect(() => {
    loadCheckList();
  }, []);
  return (
    <CustomModal
      title="Checklist"
      onClose={() => setIsChecklist(false)}
      contentClassName="form-modal"
      classesToPreventClosing={["MuiAutocomplete-option Mui-focused"]}
    >
      <SiAutocomplete
        options={CATEGORY_TABS_LIST}
        value={activeTab}
        placeholder="Checklist Type"
        onChange={(e) => {
          if (e?.value) {
            setActiveTab(e);
          } else {
            setActiveTab(null);
          }
        }}
      />
      {renderActiveTabComponent()}
    </CustomModal>
  );
}
